export const BODILY_INJURIES = '0001';
export const DAMAGE_TO_THIRD_PARTIES = '0002';
export const LUC = '0016';
